import React from "react";
import RiskGauge from "../../../risk_management/RiskGauge.jsx";
import { useSelector } from "react-redux";

function RiskGaugeWidget({ widgetId }) {
    const risk_context = useSelector(state => state.dashboard.widgets[widgetId].settings?.risk_context);
    const projectId = useSelector(state => state.dashboard.projectId);
    return (
        <RiskGauge project_id={projectId} context={risk_context} />
    );

}

export default RiskGaugeWidget;
